import { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Input } from '@/components/ui/input';

// A key or password KEYA PULSE keeps for another service - Zoko, Claude, the mail server. The
// browser fills a type="password" field with the password it saved for signing in to KEYA
// PULSE, and saving the form would store that login in its place. So this is a text field,
// dotted out with CSS once something is typed, and marked for password managers to skip.
// Never make it type="password", not even to hide the value: Chrome remembers a field that
// was once a password field and fills it from then on.
export default function SecretInput({ className = '', value, ...props }) {
  const [shown, setShown] = useState(false);
  return (
    <div className="relative">
      <Input type="text" value={value} autoComplete="off" spellCheck={false} autoCapitalize="off" autoCorrect="off"
        data-lpignore="true" data-1p-ignore="true" data-bwignore="true" data-form-type="other"
        style={shown || !value ? undefined : { WebkitTextSecurity: 'disc' }}
        className={`pr-9 ${className}`} {...props} />
      <button type="button" tabIndex={-1} onClick={() => setShown(s => !s)}
        className="absolute right-2.5 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
        aria-label={shown ? 'Hide' : 'Show'} title={shown ? 'Hide' : 'Show'}>
        {shown ? <EyeOff size={14} /> : <Eye size={14} />}
      </button>
    </div>
  );
}
